import { render, staticRenderFns } from "./Transact106.vue?vue&type=template&id=1524dfa1&scoped=true"
import script from "./Transact106.vue?vue&type=script&lang=js"
export * from "./Transact106.vue?vue&type=script&lang=js"
import style0 from "./Transact106.vue?vue&type=style&index=0&id=1524dfa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1524dfa1",
  null
  
)

export default component.exports